import { useQuery } from "@tanstack/react-query";
import request from "../utils/request";
import toast from "react-hot-toast";

export const useFetchPatientsData = (filterData, options) => {
  return useQuery({
    queryKey: ["users", filterData],
    queryFn: async () => {
      const query = new URLSearchParams(filterData).toString();
      const response = await request.getAll(
        `v2/users/search-patients?${query}`
      );

      // console.log("response", response);

      if (response.status !== "OK") {
        toast.error("There is a server side error.");
      }

      const result = {
        users: response.data.users || [],
        countryWiseUser: response.data.countryWiseUser || [],
        packageWiseUser: response.data.packageWiseUser || [],
        introducerWiseUser: response.data.introducerWiseUser || [],
        representativeWiseUser: response.data.representativeWiseUser || [],
      };

      return result;
    },
    placeholderData: () => {
      return {
        users: [],
        countryWiseUser: [],
        packageWiseUser: [],
        introducerWiseUser: [],
        representativeWiseUser: [],
      };
    },
    staleTime: 0,
    cacheTime: 0,
    ...options,
    // refetchOnWindowFocus: false,
    // refetchOnMount: true,
  });
};
